(function () {

    // Works on base of jquery validate plugin. See in bower.
    // Don't forget to add name to input
    // https://jqueryvalidation.org/

    $( ".js-m-form-validate" ).each( function() {
        $( this ).validate({
            errorElement: 'span',
            errorElementClass: 'u-l',
            errorClass: 'o-input--danger',
            validClass: "o-input--success",
            ignore: '.js-m-form-validate-ignore',
            success: function ( element ) {
                //console.log("SUCCESS");
                //element.removeClass('o-input--error').addClass('o-input--success');
            },
            errorPlacement: function (error, element) {
                //console.log("ERROR");
                element.removeClass('o-input--success').addClass('o-input--danger');
                var form_group = element.closest( ".m-form-validate-line");
                form_group.removeClass( 'has-success' ).addClass( 'has-error' );
                error.insertAfter(form_group).wrap( "<div class='u-l u-danger u-fs--tw u-pt--one u-fw--medium u-lsp--base'></div>" );
            }
        });
    } );

})();

